import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import Error from './Error';

type Props = WithTranslation & {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

type State = {
  error: Error | null;
  errorInfo?: unknown;
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    // keep console logging for developer visibility
    // You can hook this up to an external error reporting service here
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught', error, info);
    this.setState({ errorInfo: info });
  }

  handleRetry() {
    this.setState({ error: null, errorInfo: undefined });
  }

  render() {
    const { children, fallback, t } = this.props;
    if (this.state.error) {
      if (fallback) return <>{fallback}</>;
      return (
        <Error
          title={t('error.failedToLoad', 'Failed to load')}
          message={this.state.error.message || undefined}
          onRetry={this.handleRetry}
        />
      );
    }
    return <>{children}</>;
  }
}

export default withTranslation()(ErrorBoundary);
